module.exports = __webpack_public_path__ + "img/son.4bdd7a43.svg";